import React from 'react';

function PageHeader({ title, subtitle, showLogout = true }) {
    function handleLogout() {
        if (window.confirm('Bạn có chắc chắn muốn đăng xuất?')) {
            sessionStorage.clear();
            localStorage.removeItem('adminUsername'); // Xóa thông tin ghi nhớ
            window.location.href = '/';
        }
    }

    return (
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom mb-3 bg-light">
            <div>
                <h2 className="fw-bold m-0">{title}</h2>
                {subtitle && <p className="text-muted m-0">{subtitle}</p>}
            </div>
            {showLogout && (
                <button 
                    className="btn btn-outline-danger"
                    onClick={handleLogout}
                    title="Đăng xuất khỏi hệ thống"
                >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Đăng xuất
                </button>
            )}
        </div>
    );
}

export default PageHeader;